export default "__VITE_ASSET__igLfETZn__"